@if (storesInitialized) {
  @if (!userStore.isGuestView()) {
    <app-bookmark-menu
      (loadLayout)="onLoadLayout($event)"
      [activeTopic]="globalStore.activeTopic()"></app-bookmark-menu>
  }

  <app-legal-footer
    [showAtlasIcon]="!!activeCommune?.atlasConfig?.logo"></app-legal-footer>

  @if (showLandingPage) {
    <app-atlas-landingpage />
  }

  @if (!isWorkshopMode) {
    <h2 class="md:flex md:flex-wrap align-items-stretch gap-2 py-0 my-1 mx-1">
      <!-- The menu bar (which carries the logo as home button) is hidden in guest view -->
      @if (userStore.isGuestView()) {
        <div
          class="flex-shrink-0 surface-0 py-2 px-3 border-round-xl flex align-items-center mb-2 md:mb-0">
          <app-logo
            hStyleClass="h-3rem w-7rem"
            [logoFileName]="activeCommune?.atlasConfig?.logo" />
        </div>
      }
      <div
        class="atlas-headline-box surface-0 py-2 px-3 border-round-xl flex flex-column justify-content-center gap-1 flex-grow-1 mb-2 md:mb-0">
        @if (
          activeBookmark?.headline || activeBookmark?.title;
          as bookmarkHeadline
        ) {
          <span
            class="text-primary line-height-2"
            [class.text-xl]="bookmarkHeadline.length > 80"
            [class.text-2xl]="bookmarkHeadline.length <= 80"
            >{{ bookmarkHeadline }}</span
          >
          <div class="text-color-secondary font-light text-base">
            {{ activeCommune?.title || activeCommune?.name }}
          </div>
        } @else {
          {{ activeCommune?.title || activeCommune?.name }}
        }
      </div>

      @if (widgetStore.hasDataLayerWidgets()) {
        <div
          class="hidden sm:flex align-items-center flex-shrink-0 surface-0 py-2 px-3 border-round-xl">
          <app-atlas-year-controls [disableControls]="disableControls" />
        </div>
      }
    </h2>
  }

  <app-atlas-grid gridId="main"></app-atlas-grid>

  <router-outlet name="reports"></router-outlet>

  @if (globalStore.openReport()) {
    <app-district-report
      [dataLayerId]="globalStore.activeReport()?.dataLayerId"
      [districtKey]="
        globalStore.activeReport()?.districtKey
      "></app-district-report>
  }

  @if (gridStore.showBookmarkForm() || gridStore.bookmarkToEdit()) {
    <p-sidebar
      (onHide)="gridStore.closeBookmarkForm()"
      [modal]="true"
      [visible]="gridStore.showBookmarkForm()"
      [styleClass]="'w-30rem'">
      <ng-template pTemplate="header">
        <app-header
          icon="fas fa-note-sticky"
          text="Ansicht speichern"></app-header
      ></ng-template>
      <app-bookmark-form
        [cancelLevel]="0"
        [bookmark]="gridStore.bookmarkToEdit()"
        [atlasForm]="true"
        (formSubmitted)="gridStore.closeBookmarkForm()"
        (cancel)="gridStore.closeBookmarkForm()"
        [layoutOptions]="gridStore.options() || null"
        [layout]="grid?.buildSaveableLayout()"></app-bookmark-form>
    </p-sidebar>
  }

  @if (showIndicatorInfoOverlay) {
    <p-sidebar
      (onHide)="onIndicatorInfoOverlayClose()"
      [modal]="true"
      [visible]="!!infoIndicator || !!globalStore.selectedWidget()"
      [styleClass]="'w-30rem'">
      <ng-template pTemplate="headless">
        <app-info
          [indicators]="infoIndicator ? [infoIndicator] : null"
          [id]="selectedWidgetId || ''" />
      </ng-template>
    </p-sidebar>
  }

  @if (globalStore.activeStory(); as storyId) {
    <app-story-gallery [storyId]="storyId" />
  }

  <p-dialog [(visible)]="addNewColorsetDialog" [style]="{ width: '80rem' }">
    <ng-template pTemplate="header">
      <app-header
        styleClass="m-0"
        icon="fas fa-plus-circle"
        text="Farbset hinzufügen"></app-header>
    </ng-template>
    @if (addNewColorsetDialog) {
      <app-colorset-form
        [cancelLevel]="0"
        (cancel)="addNewColorsetDialog = false"
        (formSubmitted)="addNewColorsetDialog = false"></app-colorset-form>
    }
  </p-dialog>

  <p-dialog
    [(visible)]="addNewBookmarkCategoryDialog"
    [style]="{ width: '50rem' }">
    <ng-template pTemplate="header">
      <app-header
        styleClass="m-0"
        icon="fas fa-plus-circle"
        text="Themenbereich hinzufügen"></app-header>
    </ng-template>
    @if (addNewBookmarkCategoryDialog) {
      <app-bookmark-category-form
        [cancelLevel]="0"
        (cancel)="closeBookmarkCategoryDialog()"
        (formSubmitted)="
          addNewBookmarkCategoryDialog = false
        "></app-bookmark-category-form>
    }
  </p-dialog>

  <p-dialog
    styleClass="z-top"
    maskStyleClass="z-top"
    appendTo="body"
    [(visible)]="!!addWorkspaceDialog"
    [style]="{ width: '40rem' }">
    <ng-template pTemplate="header">
      <app-header
        styleClass="m-0"
        icon="fas fa-plus-circle"
        text="Arbeitsbereich hinzufügen"></app-header>
    </ng-template>
    @if (!!addWorkspaceDialog) {
      <app-workspace-form
        [type]="this.addWorkspaceDialog || undefined"
        [cancelLevel]="0"
        (cancel)="addWorkspaceDialog = ''"
        (formSubmitted)="addWorkspaceDialog = ''"></app-workspace-form>
    }
  </p-dialog>
} @else {
  <app-atlas-loading-skeleton />
}
